<template>
    <div id="withdraw-app-entry">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    async mounted () {
        try {
            const result = await this.$api.withdraw.getUserCurrentStep()
            const data = result.data
            if (data.step === 'NONE') {
                if (this.$route.name === 'withdraw-otp-test') return
                if ( !(
                        this.$route.name === 'withdraw-01'
                    )
                ) this.$router.replace({ name: 'withdraw-01' }) // unintended access by user -> navigate to home
            } else if (data.step === 'PRE_VERIFY') {
                this.$router.replace({ name: 'withdraw-02' })
            } else if (data.step === 'WAIT_USER_CONFIRM') {
                this.$router.replace({ name: 'withdraw-03' })
            }
        } catch (error) {
            console.error(error)
        }
    }
}
</script>

<style lang="scss">
</style>
